import Vue from 'vue';
import Vuex from 'vuex';
import VuexFire from 'vuexfire';
import { mapGetters } from 'vuex'
import firebase from 'firebase';

Vue.use(Vuex);
Vue.use(VuexFire);
Vue.config.debug = true;


VuexFire.mutations['AI/updateAuth'] = function (state, payload) {
  state["authData"] = payload.payload;
}


export default new Vuex.Store({
  state: {
    currentUser: {},
    contacts: {},
    users: {},
    preauth: {},
    authData: {},
    preRegistrationData: {},
    dynamic: {}
  },
  mutations: VuexFire.mutations,
  actions: {
    updateAuth (context, payload) {
      context.commit('AI/updateAuth', payload);
    }
  }

});



/** WEBPACK FOOTER **
 ** ./src/vuex/store.js
 **/